export default class Captcha {
	constructor(options) {
		options = options || {};
	    options.scene = options.scene || "nc_register_h5";
	    options.startText = options.startText || '请按住滑块，拖动到最右边';
	    options.yesText = options.yesText || '验证通过';
	    options.error300 = options.error300 || '出错了，点击<a href=\"javascript:__nc.reset()\">刷新</a>再来一次';
	    options.errorNetwork = options.errorNetwork || '网络不给力，请<a href=\"javascript:__nc.reset()\">点击刷新</a>';
	    options.callback = options.callback || function () { return true };

	    this.options = options;

	    this.appKey = 'FFFF00000000017AF126';
	    this.scene = this.options.scene;
	    this.ncToken = '';
	    this.ncSessionId = '';
	    this.ncSig = '';
	    

	    this.init();
	}

	init() {
		let _this = this;
        let appKey = this.appKey;
        let nc_token = ["appKey", (new Date()).getTime(), Math.random()].join(':');
        
        let nc_opt = {
            renderTo: "#" + this.options.containerId,
            appkey: appKey,
            scene: this.options.scene,
            token: nc_token,
            customWidth: 300,
            trans: { "key1": "code0" },
            elementID: ["usernameID"],
            is_Opt: 0,
            language: "cn",
            isEnabled: true,
            timeout: 3000,
            times: 5,
            apimap: {},
            callback: function (data) {
                _this.ncToken = nc_token;
                _this.ncSessionId = data.csessionid;
                _this.ncSig = data.sig;
       
                let params = {
                    ncAppKey: _this.appKey,
                    ncScene: _this.scene,
                    ncToken: nc_token,
                    ncSessionId: data.csessionid,
                    ncSig: data.sig
                }

                _this.options.callback(params);
            },
            error: function (s) {}
        }

        let nc = new noCaptcha(nc_opt);

        nc.upLang('cn', {
            _startTEXT: this.options.startText,
            _yesTEXT: this.options.yesText,
            _error300: this.options.error300,
            _errorNetwork: this.options.errorNetwork
        });
	}
}


// WEBPACK FOOTER //
// ./src/utils/captcha.js